/**
 * Custom Header JavaScript
 * Handles search toggle, announcement bar close, mega menu interactions
 */

(function() {
  'use strict';

  // ============================================
  // ANNOUNCEMENT BAR
  // ============================================
  function initAnnouncementBar() {
    const announcementBar = document.querySelector('.announcement-bar');
    const closeButton = document.querySelector('.announcement-bar__close');
    
    if (!announcementBar || !closeButton) return;
    
    // Check if announcement was previously closed
    const announcementClosed = sessionStorage.getItem('announcementClosed');
    if (announcementClosed === 'true') {
      announcementBar.style.display = 'none';
    }
    
    closeButton.addEventListener('click', function() {
      announcementBar.style.display = 'none';
      sessionStorage.setItem('announcementClosed', 'true');
    });
  }

  // ============================================
  // PREDICTIVE SEARCH
  // ============================================
  // Pipeline's predictive-search web component handles all search functionality
  // No custom JavaScript needed - it's built into the theme

  // ============================================
  // MEGA MENU (handled by Qkify)
  // ============================================
  // Qkify handles all mega menu interactions

  // ============================================
  // STICKY HEADER
  // ============================================
  function initStickyHeader() {
    const stickyContainer = document.querySelector('.header-sticky-container');
    if (!stickyContainer) return;

    // Only on desktop
    if (window.innerWidth <= 768) return;

    const announcementBar = document.querySelector('.announcement-bar');

    // Set CSS variable for header height (for predictive search positioning)
    function setHeaderHeight() {
      const height = stickyContainer.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    // Set initially and on resize
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    // Add a spacer div so page content doesn't jump when header goes fixed
    const spacer = document.createElement('div');
    spacer.className = 'header-sticky-spacer';
    spacer.style.cssText = 'display:none; height:0;';
    stickyContainer.parentNode.insertBefore(spacer, stickyContainer.nextSibling);

    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const announcementHeight = (announcementBar && announcementBar.offsetParent !== null)
        ? announcementBar.offsetHeight
        : 0;

      // Go fixed once announcement bar is scrolled past
      if (scrollTop >= announcementHeight) {
        if (!stickyContainer.classList.contains('is-fixed')) {
          stickyContainer.classList.add('is-fixed', 'is-scrolled');
          spacer.style.height = stickyContainer.offsetHeight + 'px';
          spacer.style.display = 'block';
        }
      } else {
        stickyContainer.classList.remove('is-fixed', 'is-scrolled');
        spacer.style.display = 'none';
        spacer.style.height = '0';
      }
    });
  }

  // ============================================
  // CART UPDATE
  // ============================================
  function initCartUpdate() {
    // Update cart count dynamically
    document.addEventListener('cart:updated', function(e) {
      const cartCount = document.querySelector('.header-cart-count');
      if (cartCount && e.detail && typeof e.detail.item_count !== 'undefined') {
        cartCount.textContent = e.detail.item_count;
        cartCount.setAttribute('data-cart-count', e.detail.item_count);
        
        // Add animation
        cartCount.style.transform = 'scale(1.3)';
        setTimeout(() => {
          cartCount.style.transform = 'scale(1)';
        }, 200);
      }
    });
  }

  // ============================================
  // ACCESSIBILITY ENHANCEMENTS
  // ============================================
  function initAccessibility() {
    // Trap focus in mega menu when opened with keyboard
    const menuItems = document.querySelectorAll('.header-nav-item.has-dropdown');
    
    menuItems.forEach(item => {
      const link = item.querySelector('.header-nav-link');
      const megaMenu = item.querySelector('.header-mega-menu');
      
      if (!link || !megaMenu) return;
      
      // Get all focusable elements in mega menu
      const focusableElements = megaMenu.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      
      if (focusableElements.length === 0) return;
      
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];
      
      // Trap focus
      megaMenu.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        
        const isExpanded = link.getAttribute('aria-expanded') === 'true';
        if (!isExpanded) return;
        
        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      });
    });
  }

  // ============================================
  // MOBILE MENU (Basic Implementation)
  // ============================================
  function initMobileMenu() {
    // Add mobile menu toggle button if needed
    // This is a placeholder - you may want to implement a full mobile menu
    const headerLogoRow = document.querySelector('.header-logo-row__left');
    
    if (window.innerWidth <= 768 && headerLogoRow) {
      // Check if mobile toggle already exists
      if (!document.querySelector('.mobile-menu-toggle')) {
        const mobileToggle = document.createElement('button');
        mobileToggle.className = 'mobile-menu-toggle header-utility-link';
        mobileToggle.setAttribute('aria-label', 'Toggle menu');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M2 5h16M2 10h16M2 15h16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        `;
        
        headerLogoRow.insertBefore(mobileToggle, headerLogoRow.firstChild);
        
        // Add mobile menu functionality here
        mobileToggle.addEventListener('click', function() {
          // Implement mobile menu open/close
          console.log('Mobile menu toggle clicked');
          // You'll need to create a mobile menu structure
        });
      }
    }
  }

  // ============================================
  // INITIALIZE ALL
  // ============================================
  function init() {
    // Only initialize on desktop
    if (window.innerWidth > 768) {
      initAnnouncementBar();
      initStickyHeader();
      initCartUpdate();
      // Pipeline's predictive-search component handles search automatically
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinitialize on AJAX page loads (if using Shopify sections)
  document.addEventListener('shopify:section:load', init);

})();
